import ActionTypes from '../constants/ActionTypes';
import createReducer from '../utils/createReducer';
import { combineReducers } from 'redux';

const list = createReducer(
  { questions: [] },
  {
    [ActionTypes.FETCH_BUN_FORM_QUESTIONS_SUCCESS]: (state, { payload }) =>
      Object.assign({}, state, { questions: payload.questions })
  }
);

const setStatusForKey = (state, { type }) => Object.assign({}, state, { questions: type });

const status = createReducer(
  {},
  {
    [ActionTypes.FETCH_BUN_FORM_QUESTIONS_REQUEST]: setStatusForKey,
    [ActionTypes.FETCH_BUN_FORM_QUESTIONS_SUCCESS]: setStatusForKey,
    [ActionTypes.FETCH_BUN_FORM_QUESTIONS_NOT_FOUND]: setStatusForKey,
    [ActionTypes.FETCH_BUN_FORM_QUESTIONS_ERROR]: setStatusForKey,
    [ActionTypes.SAVE_BUN_FORM_QUESTIONS__ERROR]: setStatusForKey,
    [ActionTypes.LOGGIN_ERROR]: setStatusForKey
  }
);

const page = createReducer(0, {
  [ActionTypes.SAVE_BUN_FORM_QUESTIONS_SUCCESS]: (state, { payload }) => payload
});

export default combineReducers({
  list,
  status,
  page
});
